import { FC } from 'react'

import styled from 'styled-components'

import { CollapsedSearchInput } from 'src/Components/CollapsedSearchInput'
import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'
type Props = {
  searchValue: string
  disabled?: boolean
  setSearchValue: (value: string) => void
}

const Container = styled.div`
  position: sticky;
  top: 0px;
  padding-top: 24px;
  padding-bottom: 24px;
  background-color: ${({ theme }) => theme.common.primaryBg};
`

const StyledSearchInput = styled(CollapsedSearchInput)`
  max-width: 600px;
  width: 100%;
  border: 1px solid ${({ theme }) => theme.common.primaryBorder};
  &.ant-input-disabled {
    border: 1px solid ${({ theme }) => theme.common.primaryBorder};
  }
  &.ant-input-affix-wrapper .ant-input-prefix {
    margin-inline-end: 8px;
  }
  @media screen and (max-width: ${MAX_MOBILE_WIDTH}) {
    border-radius: 40px;
    width: 100%;
    input::placeholder {
      visibility: visible;
    }
  }
  &:focus-visible,
  &:focus,
  &:focus-within {
    width: 100%;
    @media screen and (max-width: 767px) {
      position: relative;
      width: 100%;
      input::placeholder {
        visibility: visible;
      }
    }
  }
  input::placeholder {
    color: ${({ theme }) => theme.common.primaryPlaceholder};
  }
`

export const SpotifyGenresSearchInput: FC<Props> = ({
  searchValue,
  disabled,
  setSearchValue,
}) => (
  <Container>
    <StyledSearchInput
      disabled={disabled}
      placeholder='Enter a genre name'
      value={searchValue}
      onChange={(e) => setSearchValue(e.target.value)}
    />
  </Container>
)
